import Users                                     from "../../../pages/site/Users";
import User                                      from "../../../pages/site/User";
import {getSiteUserEditRoute, getSiteUsersRoute} from "./factory/user";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getSiteUsersRoute(),
        component: Users,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteUserEditRoute(),
        component: User,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;
